import TextField from "@mui/material/TextField";

const TextPropertyField = ({ initialValue, label, multiline, onChange, placeholder }) => (
  <TextField
    defaultValue={initialValue}
    fullWidth
    label={label}
    multiline={multiline}
    onChange={(e) => onChange?.(e.target.value)}
    placeholder={placeholder}
    size="small"
    variant="outlined"
  />
);

export default TextPropertyField;
